module.exports = __webpack_public_path__ + "static/media/a7.3c11e72a.jpg";